import * as Yup from 'yup';

export const VALIDATION_SCHEMA = t =>
  Yup.object().shape({
    amount: Yup.number()
      .min(1, t('payment_form.val_minimum_amount'))
      .required(t('payment_form.val_enter_amount')),
    method: Yup.string().required(t('payment_form.val_required_field')),
  });
